import { createSelector } from 'reselect';

const bootstrap = state => state.bootstrap;

// A reading kind's unit as the WiseMetering catalogue defines it: reading kind → indicator kind → unit.
// An adimensional kind (a power factor) has no symbol worth showing.
export const selectUnitSymbolsByReadingKindId = createSelector(
    [bootstrap],
    ({ indicator_kinds: indicatorKinds = [], reading_kinds: readingKinds = [], units = [] } = {}) => {
        const unitsById = Object.fromEntries(units.map(unit => [unit.id, unit]));
        const unitIdByIndicatorKindId = Object.fromEntries(indicatorKinds.map(kind => [kind.id, kind.unit_id]));

        return Object.fromEntries(readingKinds.map(kind => {
            const unit = unitsById[unitIdByIndicatorKindId[kind.indicator_kind_id]];
            return [kind.id, unit && unit.slug !== 'adimensional' ? unit.symbol : null];
        }));
    }
);
